module.exports = __webpack_public_path__ + "media/clownworld.fb2d0706.mp3";